<template>
  <div class="promo-panel-wrapper">
    <!-- Vertical scrollable cards -->
    <div class="promo-carousel">
      <div class="flex flex-col gap-2 py-2 px-2">
        <div v-for="promo in promoList" :key="promo.id" class="card-wrapper">
          <PromoPanelCardBeta
            :panel="promo"
            :is-select="promo.isSelect"
            @click="handleClickPromo(promo)"
          />
          <ThreeFor700Dialog
            v-if="promo.isOpenXChooseYDialog"
            :id="promo.bundleIdList[0]"
            :is-show-dialog="promo.isOpenXChooseYDialog"
            :title="promo.title"
            :width="970"
            :quantity="5"
            :promo-price="promo.finalAmount"
            show-deal-alert
            @close="promo.isOpenXChooseYDialog = false"
            @isAddToCart="addXChooseYPromo(promo, $event)"
          />
        </div>
      </div>
    </div>
    <BuildBundleStart
      :is-show-dialog="isShowBuildBundleStart"
      :bundles="xChooseYBundleList"
      :disabled-bundle-ids="disabledXChooseYBundleIds"
      @add-to-cart="addBuildBundlePromo"
      @close="isShowBuildBundleStart = false"
    />
    <DuplicateGeneticTestDialog
      v-if="showDuplicateGeneticTestDialog"
      :is-show-dialog="showDuplicateGeneticTestDialog"
      :test-name-list="getDuplicateTestNames()"
      @close="showDuplicateGeneticTestDialog = false"
      @confirm="handleDuplicateGeneticTestConfirm"
    />
  </div>
</template>
<script>
import ThreeFor700Dialog from "./three-for-700-promo-dialog/index.vue";
import PromoPanelCardBeta from './PromoPanelCardBeta.vue';
import BuildBundleStart from "./build-bundle-start/BuildBundleStart.vue";
import DuplicateGeneticTestDialog from "../order-test-panel/order-test-tabs/DuplicateGeneticTestDialog.vue";
import { mapGetters, mapState } from 'vuex';
import { fakePromo } from "@/utils/va-order-test/index.js"
import { addAnyThreeAnyFivePanelFrom3For700Dialog } from "../order-test-panel/order-test-tabs/discount-panel-tab-pane/components/discountPanelCard";
import { addBuildBundlePromoFromDialog } from "./index.js";
import { getOneTimePurchaseEligibility } from "../patientPurchaseEligibility.js";

export default {
  components: {
    PromoPanelCardBeta,
    ThreeFor700Dialog,
    BuildBundleStart,
    DuplicateGeneticTestDialog
  },
  props: {
    promoList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fakePromo: fakePromo,
      fakePromoIsSelectedList: Array(fakePromo.length).fill(false),
      isShowBuildBundleStart: false,
      showDuplicateGeneticTestDialog: false,
      currentPromo: null
    }
  },
  computed: {
    ...mapState("orderTest", ["isDbsVersion"]),
    ...mapState("orderTest/user", ["userInfo"]),
    ...mapGetters("orderTest", ["orderTestSupportObj"]),
    ...mapGetters("orderTest/tests", ["vwTestList", "serumCategorizedVwTests", "dbsCategorizedVwTests"]),
    ...mapGetters("orderTest/panels", ["bundleList"]),

    promoAndFakePromoIsSelectedList() {
      const bools = this.promoList.map(promo => { return promo.isSelect});
      return bools.concat(this.fakePromoIsSelectedList);
    },

    xChooseYBundleList() {
      const dbsVersion = this.isDbsVersion ? "at_home" : "not_at_home";
      let bundles = this.bundleList.filter(bundle =>
        bundle.category === "xChooseY" &&
        (bundle.section === dbsVersion || bundle.section === "both")
      );

      // If currentPromo has bundleIdList (from highlight card), filter to only those bundles
      if (this.currentPromo && this.currentPromo.bundleIdList && this.currentPromo.bundleIdList.length > 0) {
        const allowedBundleIds = this.currentPromo.bundleIdList;
        bundles = bundles.filter(bundle => allowedBundleIds.includes(bundle.bundleId));
      }

      return bundles;
    },

    disabledXChooseYBundleIds() {
      const supportObj = this.orderTestSupportObj || {};
      const selectedItemList = supportObj.selectedItemList || [];
      return selectedItemList
        .filter(item => item && item.category === "xChooseY" && item.bundleId)
        .map(item => item.bundleId);
    },

    // Cached eligibility data
    eligibilityData() {
      return getOneTimePurchaseEligibility();
    }
  },

  watch: {
    promoList() {
      // Trigger re-render when promo list changes
    }
  },

  mounted() {
    // if redirect from home page promo banners,
    // add promo automatically for user
    this.addPromoInUrl(this.$route.query);
  },

  methods: {
    async handleClickPromo(promo) {
      // Store current promo for dialog use
      this.currentPromo = promo;

      const primaryBundleId = promo.bundleIdList && promo.bundleIdList[0];

      // new order menu: 3 for $800/$1000/$1200 promo uses BuildBundleStart dialog
      // 18008 is for not dbs version
      // 18011 is for dbs version
      if (primaryBundleId === 18008 || primaryBundleId === 18011) {
        this.isShowBuildBundleStart = true;
        return;
      }

      // Check genetic test duplicates FIRST
      if (this.isPromoContainsGeneticDuplicate(promo)) {
        this.showDuplicateGeneticTestDialog = true;
        return;
      }

      promo.isSelect = !promo.isSelect;

      if(promo.testIdList.length > 0) {
        let [id] = [...promo.testIdList]
        promo.isSelect ? 
          this.$store.dispatch("orderTest/addSelectedTest", {id}) : 
          this.$store.dispatch("orderTest/removeSelectedTest", {id}); 
        return 
      }
      if(promo.bundleIdList.length === 1) {
        if(promo.bundleIdList[0] === 3 || promo.bundleIdList[0] === 5)  {
          promo.isOpenXChooseYDialog = true;
          return;
        } else if (promo.bundleIdList[0] === 800) {
          promo.isOpenBuildBundleDialog = true;
          return;
        } else {
          let [bundleId] = [...promo.bundleIdList]
          if (promo.isSelect) {
            let added = await this.$store.dispatch("orderTest/addSelectedDiscountPanel", {bundleId});
            if (added === false) {
              promo.isSelect = false;
            }
          } else {
            this.$store.dispatch("orderTest/removeSelectedDiscountPanel", {bundleId});
          }
        }
        
      }
      // if (!promo.quantity) { // normal promo
      //   promo.isSelect 
      //     ? this.$store.dispatch("orderTest/removeSelectedSeasonalPromo", promo)
      //     : this.$store.dispatch("orderTest/addSelectedSeasonalPromo", promo);
      // } else { // xChooseY promo
      //   if (!promo.isSelect) {
      //     promo.isOpenXChooseYDialog = true;
      //     return;
      //   } 
      //   // remove all selcted xChooseY promos
      //   let { selectedSeasonalPromoList } = this.orderTestSupportObj;
      //   selectedSeasonalPromoList.filter(p => p.id === promo.id).forEach(p => {
      //     this.$store.dispatch("orderTest/removeSelectedSeasonalPromo", p);
      //   })
      // }
      
    },
    addXChooseYPromo(promo, payload) {
      addAnyThreeAnyFivePanelFrom3For700Dialog(payload, this.orderTestSupportObj);
      promo.isOpenXChooseYDialog = false;
    },

    addBuildBundlePromo(payload) {
      addBuildBundlePromoFromDialog(payload, this.orderTestSupportObj);
    },

    changeFakePromoSelected(params) {
      const { id, isSelected } = params;
      const index = this.fakePromo.findIndex(promo => promo.id === id);
      if (index !== -1) {
        this.fakePromoIsSelectedList[index] = isSelected;
      }
    },
    addPromoInUrl(query) {
      if (query && query["item-id"] && query["item-type"] === "highlight-card") {
        let promoId = Number(query["item-id"]);
        let promo = this.promoList.find(p => p.id === promoId);
        if (!promo) {
          return;
        }
        // check if promo available for current menu
        // if not, switch to correct menu
        let currentMenu = this.isDbsVersion ? "at_home" : "not_at_home";
        if (!["both", currentMenu].includes(promo.section)) {
          this.$store.dispatch("orderTest/setIsDbsVersion", !this.isDbsVersion);
        }
        // this.$store.dispatch("orderTest/addSelectedSeasonalPromo", promo);
        this.handleClickPromo(promo);
      }
    },

    isPromoContainsGeneticDuplicate(promo) {
      // If promo is already selected, allow deselecting
      if (promo.isSelect) {
        return false;
      }

      const eligibilityData = this.eligibilityData;
      if (!eligibilityData || Object.keys(eligibilityData).length === 0) {
        return false;
      }

      // Check if testIdList has duplicates
      if (promo.testIdList && promo.testIdList.length > 0) {
        const hasDuplicate = promo.testIdList.some(testId => {
          return typeof eligibilityData[testId] !== 'undefined' &&
                 eligibilityData[testId] === false;
        });
        if (hasDuplicate) {
          return true;
        }
      }

      // Check if bundleIdList has duplicates using testIdsInPanel
      if (promo.bundleIdList && promo.bundleIdList.length > 0) {
        for (const bundleId of promo.bundleIdList) {
          const bundle = this.bundleList.find(b => b.id === bundleId || b.bundleId === bundleId);
          if (bundle) {
            // Use testIdsInPanel directly - much simpler!
            if (bundle.testIdsInPanel && bundle.testIdsInPanel.length > 0) {
              const hasDuplicate = bundle.testIdsInPanel.some(testId => {
                return typeof eligibilityData[testId] !== 'undefined' &&
                       eligibilityData[testId] === false;
              });
              if (hasDuplicate) {
                return true;
              }
            }
          }
        }
      }

      return false;
    },

    getDuplicateTestNames() {
      if (!this.currentPromo || !this.eligibilityData) {
        return [];
      }

      const duplicateTestIds = [];

      // Check testIdList
      if (this.currentPromo.testIdList && this.currentPromo.testIdList.length > 0) {
        this.currentPromo.testIdList.forEach(testId => {
          if (this.eligibilityData[testId] === false) {
            duplicateTestIds.push(testId);
          }
        });
      }

      // Check bundleIdList using testIdsInPanel
      if (this.currentPromo.bundleIdList && this.currentPromo.bundleIdList.length > 0) {
        this.currentPromo.bundleIdList.forEach(bundleId => {
          const bundle = this.bundleList.find(b => b.id === bundleId || b.bundleId === bundleId);
          if (bundle && bundle.testIdsInPanel) {
            bundle.testIdsInPanel.forEach(testId => {
              if (this.eligibilityData[testId] === false) {
                duplicateTestIds.push(testId);
              }
            });
          }
        });
      }

      return duplicateTestIds
        .map(testId => this.getTestNameById(testId));
    },

    getTestNameById(testId) {
      const test = this.vwTestList.find(t => t.id === testId);
      return test ? test.testName : `Test ${testId}`;
    },

    handleDuplicateGeneticTestConfirm() {
      // User confirmed - remove the promo from selection
      if (this.currentPromo) {
        this.currentPromo.isSelect = false;
        if (this.currentPromo.testIdList && this.currentPromo.testIdList.length > 0) {
          let [id] = [...this.currentPromo.testIdList];
          this.$store.dispatch("orderTest/removeSelectedTest", {id});
        } else if (this.currentPromo.bundleIdList && this.currentPromo.bundleIdList.length === 1) {
          let [bundleId] = [...this.currentPromo.bundleIdList];
          this.$store.dispatch("orderTest/removeSelectedDiscountPanel", {bundleId});
        }
      }
      this.showDuplicateGeneticTestDialog = false;
      this.currentPromo = null;
    }
  }
}
</script>

<style scoped>
.promo-panel-wrapper {
  width: 100%;
}

.promo-carousel {
  width: 100%;
  overflow: hidden;
}

.promo-scroll-area {
  overflow-y: auto;
  max-height: 600px;
  scroll-behavior: smooth;
}

.promo-scroll-area::-webkit-scrollbar {
  width: 8px;
}

.promo-scroll-area::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 4px;
}

.promo-scroll-area::-webkit-scrollbar-thumb {
  background: var(--VibrantDarkBlue, #004879);
  border-radius: 4px;
}

.promo-scroll-area::-webkit-scrollbar-thumb:hover {
  background: #003459;
}

.card-wrapper {
  width: 100%;
}
</style>